import customErrorMessage from "@/components/CustomErrorMessage";
import { ErrorServices } from "@/services";
import { message } from "antd";

export const handleCsvUpload = async (
  event: React.ChangeEvent<HTMLInputElement>,
  uploadFn: (formData: FormData) => any
) => {
  event.stopPropagation();
  event.preventDefault();

  const file = event.target.files?.[0];
  if (!file) return;

  const isCSV =
    file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

  if (!isCSV) {
    customErrorMessage("Only CSV files are allowed.");
    event.target.value = "";
    return;
  }

  try {
    const formData = new FormData();
    formData.append("attachment", file, file.name);

    await uploadFn(formData).unwrap();

    message.success("CSV Data Uploaded Successfully");
  } catch (err: any) {
    ErrorServices(err); // 🔥 centralized error handling
  } finally {
    event.target.value = "";
  }
};
